// extracted by mini-css-extract-plugin
var _1 = "disabled__S8Tdt";
var _2 = "fullWidth__lBL7f";
var _3 = "mainButton__atI44";
var _4 = "outlined__P_FbA";
var _5 = "secondary__c1ohb";
var _6 = "spinnerWrapper__RHIIA";
var _7 = "text__eAyfM";
var _8 = "toggleOffMode__N8hoA";
var _9 = "warning__zijWm";
export { _1 as "disabled", _2 as "fullWidth", _3 as "mainButton", _4 as "outlined", _5 as "secondary", _6 as "spinnerWrapper", _7 as "text", _8 as "toggleOffMode", _9 as "warning" }
export default { "disabled": _1, "fullWidth": _2, "mainButton": _3, "outlined": _4, "secondary": _5, "spinnerWrapper": _6, "text": _7, "toggleOffMode": _8, "warning": _9 }
